import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Text } from "@chakra-ui/react";
import { useAppDispatch } from "../../store";
import { useParams } from "react-router-dom";
import { fetchRecruitersByDepartment } from "../../store/slices/vacancy";
import api from "../../api";
import { UserRole } from "api/auth/types";
import { useEffect, useState } from "react";

interface SelectRecruiterRoleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (role: UserRole) => void;
    recruiterFullName: string;
    roles: { value: UserRole; label: string }[];
    defaultRole?: UserRole;
    recruiterId: number;
    isLoading?: boolean;
    departmentId?: number;
}

export const SelectRecruiterRoleModal = ({
    isOpen,
    onClose,
    onSave,
    recruiterFullName,
    roles,
    defaultRole,
    recruiterId,
    isLoading = false,
    departmentId,
}: SelectRecruiterRoleModalProps) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const effectiveDepartmentId = departmentId ?? (id ? Number(id) : null);
    const [selectedRole, setSelectedRole] = useState<UserRole | undefined>(defaultRole);

    useEffect(() => {
        setSelectedRole(defaultRole);
    }, [defaultRole]);

    const handleSave = () => {
        if (!selectedRole) return;
        onSave(selectedRole);

        api.user.userUpdateRole({
            param: { id: recruiterId },
            data: { role: selectedRole }
        }).finally(() => {
            dispatch(fetchRecruitersByDepartment({ department_id: effectiveDepartmentId }));
            onClose();
        });
    };

    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay backdropFilter="blur(3px)" />
            <ModalContent maxW="50vw" gap="24px" px="24px" paddingTop="32px" paddingBottom="24px">
                <ModalHeader p={0}>Выбрать роль для {recruiterFullName}</ModalHeader>
                <ModalBody>
                    <Text mb={2}>Выберите новую роль для сотрудника</Text>
                    <Select id="select-recruiter-role" value={selectedRole} onChange={(e) => setSelectedRole(e.target.value as UserRole)}>
                        {roles.map((r) => (
                            <option key={r.value} value={r.value}>{r.label}</option>
                        ))}
                    </Select>
                </ModalBody>
                <ModalFooter p={0} pt="8px">
                    <Flex gap="12px">
                        <Button variant="outline" onClick={onClose}>Отмена</Button>
                        <Button colorScheme="blue" onClick={handleSave} isLoading={isLoading}>Сохранить</Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};


